import { gql } from "@apollo/client"

export const CountrySalesFields = gql`
  fragment CountrySalesFields on CountrySales {
    mightSellInChina
    mightSellInIsrael
    mightSellInColombia
    mightSellInBolivia
  }
`
